import React from "react";
import {
  Facebook,
  Instagram,
  Twitter,
  Linkedin,
} from "lucide-react";
import { Link } from "react-router-dom";
import zolaLogo from '../Navbar/zola-black.png'

const NewFooter = () => {
  return (
    <footer className="w-full bg-[#f9fafb] py-16 mt-20">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-12">
        {/* Logo and tagline */}
        <div className="flex flex-col items-start gap-4">
          <img
            src={zolaLogo}
            alt="Zola Logo"
            className="h-8 w-auto object-contain"
          />
          <p className="text-gray-600 text-sm max-w-xs">
            Improve Client Engagement, Amplify Your Success.
          </p>
          {/* Socials */}
          {/* <div className="flex gap-4 mt-4">
            <a href="#" className="text-gray-500 hover:text-[#7f56d9]">
              <Instagram size={20} />
            </a>
            <a href="#" className="text-gray-500 hover:text-[#7f56d9]">
              <Facebook size={20} />
            </a>
            <a href="#" className="text-gray-500 hover:text-[#7f56d9]">
              <Twitter size={20} />
            </a>
            <a href="#" className="text-gray-500 hover:text-[#7f56d9]">
              <Linkedin size={20} />
            </a>
          </div> */}
        </div>

        {/* Product Links */}
        <div>
          <h4 className="text-gray-900 font-semibold mb-4">Product</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/reviews" className="text-gray-600 hover:text-[#7f56d9]">Reviews</Link></li>
            <li><Link to="/ai-surveys" className="text-gray-600 hover:text-[#7f56d9]">Surveys</Link></li>
            <li><Link to="/nps" className="text-gray-600 hover:text-[#7f56d9]">NPS & CSAT</Link></li>
            <li><Link to="/coupons" className="text-gray-600 hover:text-[#7f56d9]">Coupons</Link></li>
            <li><Link to="/referrals" className="text-gray-600 hover:text-[#7f56d9]">Referrals</Link></li>
          </ul>
        </div>

        {/* Industries Links */}
        <div>
          <h4 className="text-gray-900 font-semibold mb-4">Industries</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2">
              <Link to="/real-estate" className="text-gray-600 hover:text-[#7f56d9]">Real Estate</Link>
              <span className="bg-green-100 text-green-700 text-xs font-medium px-2 py-0.5 rounded-full">
                New
              </span>
            </li>
            <li><Link to="/restaurant" className="text-gray-600 hover:text-[#7f56d9]">Restaurants</Link></li>
            <li><Link to="/home-maintenance" className="text-gray-600 hover:text-[#7f56d9]">Home Maintenance</Link></li>
          </ul>
        </div>

        {/* Contact Us */}
        <div>
          <h4 className="text-gray-900 font-semibold mb-4">Contact us</h4>
          <ul className="space-y-3 text-sm">
            <li><a href="mailto:sales@zolatap.com" className="text-gray-600 hover:text-[#7f56d9]">sales@zolatap.com</a></li>
            <li><a href="tel:+18013618524" className="text-gray-600 hover:text-[#7f56d9]">(801) 361-8524</a></li>
          </ul>
        </div>
      </div>

      {/* Bottom small text */}
      <div className="mt-12 border-t border-gray-200 pt-6 text-center text-xs text-gray-500 flex flex-col md:flex-row md:justify-between items-center gap-4 px-6">
        <p>© {new Date().getFullYear()} Zola. All rights reserved.</p>
        <div className="flex gap-6">
          <Link to="/terms-of-service"className="hover:text-[#7f56d9]">Terms Of Services</Link>
          {/* <a href="#" className="hover:text-[#7f56d9]">Privacy</a>
          <a href="#" className="hover:text-[#7f56d9]">Cookies</a> */}
        </div>
      </div>
    </footer>
  );
};

export default NewFooter;
